<template>
  <div class="form-builder observation-create">
    <div>
      <h1>{{ observationLabel }}</h1>
    </div>
    <md-card>
      <md-card-content>
        <div v-if="learners.length != 0 && observations.length != 0" class="md-layout">

          <div class="md-layout-item">
            <md-field class="fb-select">
              <label for="select-view-observation">{{ observationLabel }} Type:</label>
              <md-select
                placeholder="- Select -"
                id="select-view-observation"
                v-model="observation"
                :multiple="false"
              >
                <md-option
                  v-bind:key="index"
                  v-for="(option, index) in observations"
                  :value="option.value"
                >{{option.label}}</md-option>
              </md-select>
            </md-field>
            <md-field class="fb-select">
              <label for="select-view-learner">{{ observationLabel }} for:</label>
              <md-select
                placeholder="- Select -"
                id="select-view-learner"
                v-model="learner"
                :multiple="false"
              >
                <md-option
                  v-bind:key="index"
                  v-for="(option, index) in learners"
                  :value="option.value"
                >{{option.label}}</md-option>
              </md-select>
              <span class="md-helper-text"></span>
            </md-field>
            <div class="date">
              <md-field class="fb-select">
                <label>{{ observationLabel }} Date:</label>
              </md-field>
              <datetime value-zone="local" v-model="date" placeholder="Select date" type="date" format="MM/dd/yyyy">
              </datetime>
              <datetime class="time" value-zone="local" v-model="time" placeholder="Select time (optional)" type="time" format="h:mm a" use12-hour>
              </datetime>
            </div>

            <md-field :class="messageClass" class="no-line justify-content-center msg">
              <span class="md-helper-text"></span>
              <span v-if="observation == null" class="md-error">Please select {{ observationLabel }} Type.</span>
              <span v-if="learner == null"  class="md-error">Please select Learner.</span>
              <span v-if="date == ''"  class="md-error">Please select {{ observationLabel }} Date.</span>
            </md-field>
          </div>

          <div class="md-layout-item md-layout md-alignment-center-center action-buttons">
            <md-button class="md-button" @click="save">Save</md-button>
            <md-button class="md-primary" @click="start">Save & Start {{ observationLabel }}</md-button>
          </div>
        </div>
        <div v-else class="md-layout">
          <h3>You do not have any learners or {{ observationLabel }} types assigned.</h3>
        </div>
      </md-card-content>
    </md-card>
    <spinner v-if="showLoader"></spinner>
  </div>
</template>

<script>
import Activity from "./Activity";
import Spinner from "./components/Spinner.vue";
import { Datetime } from 'vue-datetime';

export default {
  name: "Temporary",
  props: ["mode", "nid", "sid", "noTemplate"],
  mixins: [Activity],
  data() {
    return {
      learner: null,
      learners: window.drupalSettings.learners,
      observations: window.drupalSettings.observations,
      observationLabel: window.drupalSettings.group_catch_config.labels.observation_label,
      date: null,
      time: null,
      observation: null,
      menuOpen: false,
      showLoader: false,
      valid: true
    };
  },
  components: {
    Spinner,
    Datetime
  },
  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid
      };
    }
  },
  mounted() {
    //this.$material.locale.dateFormat = 'MM/dd/yyyy';
    //this.$el.querySelector('input.md-select-value').setAttribute('aria-label', 'Input Select Learners');
    //this.$el.querySelector('input.md-input-fake').setAttribute('aria-label', 'Learners');
    //this.$el.querySelector('select').setAttribute('aria-label', 'Select Learners');
    this.$el.querySelectorAll('input.md-input-fake').forEach((item) => {
      item.setAttribute('aria-hidden', true);
    });
    this.$el.querySelectorAll('select').forEach((item) => {
      if (!item.options.length) {
        item.append(document.createElement('option'));
      }
      item.setAttribute('aria-hidden', true);
    });
  },
  methods: {
    log(msg) {
      console.log(msg);
    },
    validate() {
      if (this.observation && this.learner && this.date) {
        this.valid = true;
        return;
      }
      this.valid = false;
    },
    save() {
      this.validate();
      if (!this.valid) {
        return;
      }
      this.showLoader = true;
      return this.sendObservationRequest(false, false).then(json => {
        // this.showLoader = false;
        window.location.href = "/observations";
      }).catch(e => {
        this.showLoader = false;
        // TODO: Add error you page
        throw new Error(e);
      });
    },
    start() {
      this.validate();
      if (!this.valid) {
        return;
      }

      this.showLoader = true;
      return this.sendObservationRequest(false, true).then(json => {

        // alert("ok");
        // this.showLoader = false;
        window.location.href =
          "/observation/" + json.data.attributes.drupal_internal__id;
      }).catch(e => {
        this.showLoader = false;
        // TODO: Add error you page
        throw new Error(e);
      });
    },


    sendObservationRequest(isDraft, isStarted) {
      let self = this;

      let type = isDraft
        ? self.$submission_type.SUBMISSION_TYPE_TEMP
        : self.$submission_type.SUBMISSION_TYPE_MAIN;
      return self.getToken().then(() => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", self.token);
        //let date = new Date(self.date);
        /*if (self.time) {
          let time = new Date(self.time);
          date.setHours(time.getHours());
          date.setMinutes(time.getMinutes());
        }*/

        let method = "POST";
        let value = {
          date: self.date
        };

        value.isDraft = isDraft;
        value.isStarted = isStarted;

        let a_data = {
          data: {
            type: "observation_submission--observation_submission",
            attributes: {
              data: JSON.stringify(value),
              submission_type: type,
              is_draft: isDraft,
              date: self.date
                ? parseInt(self.$moment(self.date).format("X"))
                : null,
              time: self.time
                ? parseInt(self.$moment(self.time).format("X"))
                : null,

            },
            relationships: {
              observation: {
                data: {
                  type: "node--observation",
                  id: self.observation
                }
              },
              learner: {
                data: {
                  type: "user--user",
                  id: self.learner
                }
              }
            }
          }
        };
        return fetch("/jsonapi/observation_submission/observation_submission", {
          credentials: "include",
          method: method,
          headers: fetch_headers,
          body: JSON.stringify(a_data)
        })
          .then(response => {
            return response.json();
          })
          .then(json => {
            if (json && json.errors && json.errors.length) {
              throw new Error(json.errors[0].title);
            }
            return json;
          });
      });
    }
  }
};
</script>
<style lang="scss">
.md-align-text-right {
  text-align: right;
}
.observation-create {
  .action-buttons {
    @media all and (max-width: $breakpoint-medium) {
      min-width: 100%;
      margin-top: 20px !important;
    }
  }
  .date {
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    .fb-select {
      width: auto;
      white-space: nowrap;

      @media all and (max-width: $breakpoint-medium) {
        width: 100%;
        text-align: left;
        margin-bottom: 10px;
      }

    }
    .md-datepicker {
      max-width: 375px;
    }
  }
  .md-field.fb-select {
    .md-select {
      max-width: 375px;
    }
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    label {
      margin-bottom: 0;
      margin-right: 10px;
      top: 0;
      @media all and (max-width: $breakpoint-medium) {
        width: 100%;
        text-align: left;
        margin-bottom: 10px;
      }
    }
  }
  .vdatetime-popup {
    font-family: "Source Sans Pro", sans-serif;
  }
  .vdatetime {
    display: flex;
    justify-content: center;
    align-items: center;
    &:before {
      display: flex;
      float: left;
      align-items: center;
      height: 30px;
      content: "date_range";
      font-size: 25px;
      color: rgba(0, 0, 0, 0.54);
      font-family: "Material Icons";
    }
    &.time {
      &:before {
        display: flex;
        float: left;
        align-items: center;
        height: 30px;
        content: "schedule";
        font-size: 25px;
        color: rgba(0, 0, 0, 0.54);
        font-family: "Material Icons";
      }
    }
  }
  .vdatetime-input {
    border: none !important;
    border-bottom: 2px solid rgb(195, 195, 195) !important;
    font-size: 16px;
    font-family: $font-source-sans-pro;
    color: rgb(60, 60, 60);

  }
  .msg {
    display: none;
    &.md-invalid {
      display: block;
    }
  }
  .md-error {
    position: relative !important;
    bottom: unset !important;
    top: unset !important;
  }
}
</style>
